import React, { ReactNode, useMemo } from 'react';

import styled from '@emotion/styled';
import { StyledCard } from './StyledCard';
import { Responsive } from '../../utils';
import { FixedGrid, IFixedGridProps } from '../Grid';
import {
	CardContainerContext,
	ICardContainerContextValues,
} from './CardContainerContext';
import { IStyledComponentSelector } from '../../types';
import { UnstyledUl } from '../List';

export type CardOrientation = 'horizontal' | 'vertical';

export interface ICardsContainerProps extends ICardContainerContextValues {
	children: ReactNode;
	columns: Responsive.IValueOrResponsiveValue<number>;
	itemSelector?: IStyledComponentSelector;
}

interface IStyledCardsContainerProps extends IFixedGridProps {
	fullyClickable?: boolean;
}

const StyledCardsContainer = styled(
	FixedGrid.withComponent(UnstyledUl),
)<IStyledCardsContainerProps>``;

StyledCardsContainer.defaultProps = {
	itemSelector: StyledCard,
};

export function CardsContainer({
	children,
	columns,
	...rest
}: ICardsContainerProps) {
	const restValue = useMemo(() => ({ ...rest }), [rest]);

	return (
		<CardContainerContext.Provider value={restValue}>
			<StyledCardsContainer columns={columns} {...rest}>
				{' '}
				{children}
			</StyledCardsContainer>
		</CardContainerContext.Provider>
	);
}
